import React, {useEffect, useState} from 'react';
import {
   StyleSheet,
   View,
   Text,
   Image,
   TouchableOpacity,
   Dimensions,
   Platform,
   ActivityIndicator,
} from 'react-native';
//import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import {
   white,
   drawerListBackgroundColor,
   moduleComplitedPercentage,
   trCurrentProgressLevel,
   module_Level,
   hour_Level,
   trainingValidity_Level,
   FONT_FAMILY_REGULAR,
   ActivityLoaderColor,
   isMacOS,
} from '../../utils/utils';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import {selectDashboardRefresh} from '../../redux/slices/DashboardRefreshSlice';

export const CourseListItem = ({
   item,
   onItemClick,
   courseNameId,
   setCourseNameId,
   numOfCols,
   emptyCard,
   num,
   index,
}) => {
   const moduleLevel = module_Level(item);
   const hourLevel = hour_Level(item);
   const courseValidityLevel = trainingValidity_Level(item);
   var mPrecent = moduleComplitedPercentage(item);
   var currentProgress = trCurrentProgressLevel(item);
   const isLandscapemode = useSelector(selectScreenOrientation);
   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const isMobilePlatform = isIOS || isAndroid;
   const courseItemSmScreenWidth = Dimensions.get('screen').width * 0.4 - 90;
   const courseItemLgScreenWidth = Dimensions.get('screen').width * 0.4 - 220;
   const finalWidth = isMobilePlatform
      ? courseItemSmScreenWidth
      : courseItemLgScreenWidth;
   //var currentProgress = getCourseProgressLevel(item, finalWidth * 0.9 - 16 * 2); //trCurrentProgressLevel(item);
   const isWeb = Platform.OS === 'web';
   const [loading, setLoading] = useState(true);
   const [courseLoader, setCourseLoader] = useState(false);
   const handleImageLoad = () => {
      setLoading(false);
   };
   const [hover, setHover] = React.useState(false);
   const [isItemDisabled, setIsItemDisabled] = useState(false);
   const isDashboardRefreshed = useSelector(selectDashboardRefresh);
   const cardMaxWidth =
      numOfCols == 3 ? '33.3%' : numOfCols == 2 ? '49%' : '100%';
   useEffect(() => {
      if (isDashboardRefreshed) {
         if (item?.courseNameID === courseNameId) {
            setCourseLoader(true);
            setIsItemDisabled(true);
         } else {
            setCourseLoader(false);
            setIsItemDisabled(false);
         }
      } else {
         setCourseLoader(false);
         setIsItemDisabled(false);
         setCourseNameId('');
      }
   }, [isDashboardRefreshed]);

   /**
    * @Empty Card Container
    * @Style properties
    */
   const containerStyle = [
      styles.cardContainer,
      {
         width: isLandscapemode
            ? Platform.OS === 'windows'
               ? '99%'
               : '100%'
            : null,
         maxWidth: isLandscapemode ? '50%' : cardMaxWidth,
         marginTop: isMobilePlatform && !isLandscapemode ? 8 : null,
         //marginBottom: isMobilePlatform && !isLandscapemode ? 4 : null,
         ...Platform.select({
            web: {
               flexDirection: 'row',
               maxWidth: isLandscapemode ? '33.33%' : '100%',
               width: isLandscapemode ? '33.33%' : null,
               margin: isLandscapemode ? 4 : null,
               marginVertical: isLandscapemode ? 1 : null,
            },
            macos: {
               flexDirection: 'row',
               maxWidth: '33%',
               margin: isMobilePlatform && !isLandscapemode ? null : 4,
            },
            windows: {
               maxWidth: cardMaxWidth,
               width: cardMaxWidth,
               margin: 4,
               padding: null,
               //backgroundColor: 'pink',
            },
            android: {
               padding: null,
               paddingBottom: isLandscapemode ? 4 : null,
               marginHorizontal: 7,
               marginVertical: isLandscapemode ? 8 : 0,
               //backgroundColor: 'yellow',
            },
            ios: {
               padding: null,
               paddingBottom: isLandscapemode ? 4 : null,
               marginHorizontal: 7,
               marginVertical: 0,
               //backgroundColor: 'yellow',
            },
         }),
      },
   ];
   /**
    * @Grid Content Card
    * @Style properties
    */
   const containerGridStyle = [
      styles.cardContainer,
      {
         width: isLandscapemode
            ? Platform.OS === 'windows'
               ? '99%'
               : isIOS
               ? null
               : '100%'
            : null,
         // margin: isMobilePlatform && !isLandscapemode ? 0 : 4,
         marginTop: isMobilePlatform && !isLandscapemode ? 0 : null,
         marginBottom: isMobilePlatform && !isLandscapemode ? 0 : null,
      },
      {
         ...Platform.select({
            web: {
               //width: '97.5%',
               width: 423,
               height: isLandscapemode ? 190 : 200,
               marginTop: 8,
               overflow: 'hidden',
            },
            windows: {
               width: '99.5%',
               marginTop: null,
               marginBottom: null,
               paddingBottom: null,
            },
         }),
      },
   ];
   /**
    * @Empty Card UI
    */
   const EmptyCardUI = () => (
      <View style={containerStyle}>
         <View style={containerGridStyle} />
      </View>
   );
   return (
      <>
         <TouchableOpacity
            style={containerStyle}
            disabled={isItemDisabled}
            onMouseEnter={() => {
               setHover(true);
            }}
            onMouseLeave={() => {
               setHover(false);
            }}
            onStartShouldSetResponder={() => false}
            onResponderStart={() => {
               //this.setStyles(activeStyle)
            }}
            onResponderRelease={() => {
               //this.setStyles(this.state.hover ? hoverStyle : style)
            }}
            onPress={() => {
               onItemClick(item);
               setCourseNameId(item.courseNameID);
            }}>
            <View style={containerGridStyle}>
               {(loading || courseLoader) && (
                  <ActivityIndicator
                     size={'small'}
                     //color={'#001231'}
                     color={ActivityLoaderColor}
                     style={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1,
                     }}
                  />
               )}
               <Image
                  source={{uri: item?.imageURL}}
                  style={[
                     styles.cardBackgroundImage,
                     {
                        height: isLandscapemode ? '120%' : '115%',
                     },
                  ]}
                  onLoadEnd={handleImageLoad}
               />
               <View style={styles.cardContent}>
                  <UISvg
                     height="100%"
                     width="100%"
                     x1="0%"
                     y1="100%"
                     x2="0%"
                     y2="0%"
                     offset={['30%', '100%']}
                     stopColor={['#000', '#000']}
                     stopOpacity={[hover ? '0.5' : '0.8', hover ? '0' : '0.1']}
                  />
                  <View
                     style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        width: '100%',
                        padding: 16,
                     }}>
                     <Image
                        source={require('../../assets/tick_circle.png')}
                        style={{width: 20, height: 0, marginRight: 0}}
                     />
                     <Text
                        style={{
                           fontSize: 14,
                           color: white,
                           fontFamily: FONT_FAMILY_REGULAR,
                           fontWeight: '700',
                           marginRight: 10,
                        }}>
                        {' '}
                        {item.modulesCompleted}/{item.coursemodulecount}
                     </Text>
                     <UICircularProgress
                        size={40}
                        width={Platform.OS === 'web' ? 10 : 5}
                        fill={mPrecent}
                        rotation={0}
                        tintColor="#26E555"
                        trailStroke="#1C222B"
                        backgroundColor="#1C222B"
                        img={require('../../assets/course_hightlight_24.png')}
                        imgWidth={17}
                        imgHeight={18.19}
                        showPercent={false}
                        background={true}
                        bgOpacity={Platform.OS === 'web' ? 0.6 : 1}
                        trailOpacity={0}
                        imgTintClr={'white'}
                     />
                  </View>

                  <View style={styles.courseTitleDetails}>
                     {/** View having SVG Gradient*/}
                     <UISvg
                        height="100%"
                        width="100%"
                        x1="0%"
                        y1="100%"
                        x2="0%"
                        y2="0%"
                        offset={['0%', '100%']}
                        stopColor={[
                           drawerListBackgroundColor,
                           drawerListBackgroundColor,
                        ]}
                        stopOpacity={['0.5', '0']}
                        rectWidth={'100%'}
                        rectHeight={isMacOS ? 70 : '100%'}
                     />

                     {/*Title, Modules no., duration , progress etc. details below*/}
                     <Text
                        numberOfLines={2}
                        textAlignVertical="bottom"
                        style={[styles.courseTitle]}>
                        {item.coursename}
                     </Text>
                     <View style={{flexDirection: 'row', marginLeft: 16}}>
                        <View
                           style={{flexDirection: 'row', alignItems: 'center'}}>
                           <Image
                              source={require('../../assets/course_hightlight_24.png')}
                              style={{
                                 width: 10,
                                 height: 10,
                                 resizeMode: 'contain',
                              }}
                           />
                           <Text
                              style={{
                                 fontSize: 8,
                                 fontWeight: '600',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: 'white',
                                 marginLeft: 5,
                                 marginRight: 8,
                              }}>
                              {' '}
                              {moduleLevel}
                           </Text>
                        </View>

                        <View
                           style={{flexDirection: 'row', alignItems: 'center'}}>
                           <Image
                              source={require('../../assets/Timer.png')}
                              style={{
                                 width: 10,
                                 height: 10,
                                 resizeMode: 'contain',
                              }}
                           />
                           <Text
                              style={{
                                 fontSize: 8,
                                 fontWeight: '600',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: 'white',
                                 marginLeft: 5,
                                 marginRight: 8,
                              }}>
                              {hourLevel}
                           </Text>
                        </View>
                        <View
                           style={{flexDirection: 'row', alignItems: 'center'}}>
                           <Image
                              source={require('../../assets/Check.png')}
                              style={{
                                 width: 10,
                                 height: 10,
                                 resizeMode: 'contain',
                              }}
                           />
                           <Text
                              style={{
                                 fontSize: 8,
                                 fontWeight: '600',
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: 'white',
                                 marginLeft: 5,
                                 marginRight: 8,
                              }}>
                              {courseValidityLevel}
                           </Text>
                        </View>
                     </View>
                     <View
                        style={{
                           width: '100%',
                           justifyContent: 'center',
                           alignItems: 'center',
                        }}>
                        <View
                           style={{
                              width: '95%',
                              //marginLeft: Platform.OS === 'windows' ? 20 : 16,
                              //marginRight: 16,
                              marginBottom: 9,
                              marginTop: 12,
                              background: 'rgba(217, 217, 217, 8)',
                              borderRadius: Platform.OS === 'windows' ? 3 : 10,
                              borderWidth: 0.25,
                              borderColor: 'lightgray',
                              ...Platform.select({
                                 web: {
                                    marginRight: 0,
                                 },
                              }),
                           }}>
                           <View
                              style={{
                                 width: currentProgress,
                                 height: 8,
                                 backgroundColor: '#26E555',
                                 borderRadius:
                                    Platform.OS === 'windows' ? 3 : 10,
                                 justifyContent: 'center',
                              }}
                           />
                        </View>
                     </View>
                  </View>
               </View>
            </View>
         </TouchableOpacity>
         {emptyCard > 0 && num > 0 && num - 1 === index && <EmptyCardUI />}
         {emptyCard > 1 && num > 0 && num - 1 === index && <EmptyCardUI />}
      </>
   );
};

const styles = StyleSheet.create({
   cardContainer: {
      borderRadius: 8,
      borderBottomEndRadius: 10,
      borderBottomStartRadius: 10,
      overflow: 'hidden',
      height: 200,
      //margin: 4,
      flex: 1,
   },
   cardBackgroundImage: {
      position: 'absolute',
      resizeMode: 'cover',
      width: '100%',
      height: '100%',
   },
   cardContent: {
      width: '100%',
      height: '100%',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
   },
   courseTitle: {
      marginLeft: 16,
      fontSize: 14,
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      marginBottom: 6,
      marginTop: 12,
      marginRight: 10,
   },

   courseTitleDetails: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      minHeight: 70,
      // color: 'white',
   },
   hover: {
      //transition: 'all 100ms ease',
      //transform: 'scale(1.05)',
      //boxShadow: '0 0 8px rgba(0, 0, 0, 0.5)',
      borderBlockColor: '#000',
      width: 250,
   },
});
